import Api from "@/helpers/api";
import store from "@/store";
import { useConnStore } from "@/serviforms/Datasource/Connections/store";
import { useFormsListStore } from "@/serviforms/forms/store";

const logout = async () => {
  try {
    await Api.get("/auth/logout");
  } catch (error) {
    console.log("Error: logout ", error);
  }
};

const clearStore = () => {
    store.commit('resource/RESET_DATA');
    // store.commit('usuarios/RESET_DATA');
    useConnStore().$reset();
    useFormsListStore().$reset();
};

export { logout, clearStore };
